import { inject, Injectable } from '@angular/core';
import moment from 'moment';
import { Notification } from '@aid/notifications/types/classes';
import { Observable } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { FirebaseService } from '@aid/core/firebase/firebase.service';

@Injectable()
export class NotificationsChannelService {
  private readonly firebase = inject(FirebaseService);

  subscribe(memberId: number): Observable<Notification> {
    const currentDate = moment().toDate();
    return this.firebase
      .valueChanges<Notification>('notifications', [
        {
          kind: 'where',
          field: 'memberId',
          operation: '==',
          value: memberId
        },
        {
          kind: 'where',
          field: 'creationDate',
          operation: '>=',
          value: currentDate
        },
        { kind: 'orderBy', field: 'creationDate', direction: 'desc' },
        { kind: 'limit', count: 1 }
      ])
      .pipe(
        map(values => values[0]),
        filter(value => !!value),
        debounceTime(200)
      );
  }
}
